import React, { useState, useEffect } from 'react';
import { updateBodyClass } from '../../utils/function';
import { CONFIG } from '../../utils/config';

const ResetPasswordCompleted: React.FC = () => {
  // Add specific class to body on component mount
 // Add specific class to body on component mount
 useEffect(() => {
  document.title = 'Ολοκλήρωση διαδικασίας επαναφοράς του συνθηματικού'; // Set the title of the page
  updateBodyClass('auth-page');
  return () => {
    document.title = ''; // Reset title on unmount
    updateBodyClass('');
  };
}, []);


  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
    <div className="confirmation-card text-center">
        <i className="bi bi-envelope-check confirmation-icon"></i>
        <h3 className="mt-3">Ολοκλήρωση διαδικασίας</h3>
        <p className="mt-3 mb-4">Η διαδικασία επαναφοράς του συνθηματικού σας ολοκληρώθηκε. Πατήστε σύνδεση για να προχωρήσετε.</p>
        <a href={CONFIG.urls.getLoginUrl()} className="btn btn-primary w-100">Σύνδεση</a>
    </div>
</div>

  );
};

export default ResetPasswordCompleted;

